/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Types from '../../../../graphql/generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type IInternalRegulationObligationsQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.IInternalRegulationObligationsInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type IInternalRegulationObligationsQuery = {
  __typename?: 'Query';
  internalRegulationObligationsByDocument: {
    __typename: 'InternalRegulationObligationConnection';
    edges: Array<{
      __typename: 'InternalRegulationObligationEdge';
      cursor: string;
      node: {
        __typename: 'InternalRegulationObligation';
        id: string;
        title?: string | null;
        segmentId?: string | null;
        reviewStatus?: Types.IInternalRegulationObligationReviewStatus | null;
        mappingsReviewStatus?: Types.IInternalRegulationObligationReviewStatus | null;
        fragment?: {
          __typename: 'InternalRegulationFragmentConnection';
          edges: Array<{
            __typename: 'InternalRegulationFragmentEdge';
            cursor: string;
            node: {
              __typename: 'InternalRegulationFragment';
              id: string;
              title?: string | null;
              body?: string | null;
              reference?: string | null;
              label?: string | null;
              obligations?: {
                __typename: 'InternalRegulationObligationConnection';
                edges: Array<{
                  __typename: 'InternalRegulationObligationEdge';
                  cursor: string;
                  node: {
                    __typename: 'InternalRegulationObligation';
                    id: string;
                    title?: string | null;
                    reviewStatus?: Types.IInternalRegulationObligationReviewStatus | null;
                    mappingsReviewStatus?: Types.IInternalRegulationObligationReviewStatus | null;
                  };
                }>;
                pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
              } | null;
            };
          }>;
          pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
        } | null;
      };
    }>;
    pageInfo: { __typename: 'CursorPageInfo'; hasNextPage: boolean; endCursor?: string | null };
  };
};

export const InternalRegulationObligationsDocument = gql`
  query InternalRegulationObligations($input: InternalRegulationObligationsInput, $first: Int, $after: String) {
    internalRegulationObligationsByDocument(input: $input, first: $first, after: $after) {
      __typename
      edges {
        __typename
        node {
          __typename
          id
          title
          segmentId
          reviewStatus
          mappingsReviewStatus
          fragment {
            __typename
            edges {
              __typename
              node {
                __typename
                id
                title
                body
                reference
                label
                obligations {
                  __typename
                  edges {
                    __typename
                    node {
                      __typename
                      id
                      title
                      reviewStatus
                      mappingsReviewStatus
                    }
                    cursor
                  }
                  pageInfo {
                    __typename
                    hasNextPage
                    endCursor
                  }
                }
              }
              cursor
            }
            pageInfo {
              __typename
              hasNextPage
              endCursor
            }
          }
        }
        cursor
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`;

/**
 * __useInternalRegulationObligationsQuery__
 *
 * To run a query within a React component, call `useInternalRegulationObligationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInternalRegulationObligationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInternalRegulationObligationsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useInternalRegulationObligationsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    IInternalRegulationObligationsQuery,
    IInternalRegulationObligationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<IInternalRegulationObligationsQuery, IInternalRegulationObligationsQueryVariables>(
    InternalRegulationObligationsDocument,
    options,
  );
}
export function useInternalRegulationObligationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    IInternalRegulationObligationsQuery,
    IInternalRegulationObligationsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<IInternalRegulationObligationsQuery, IInternalRegulationObligationsQueryVariables>(
    InternalRegulationObligationsDocument,
    options,
  );
}
// @ts-ignore
export function useInternalRegulationObligationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    IInternalRegulationObligationsQuery,
    IInternalRegulationObligationsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<IInternalRegulationObligationsQuery, IInternalRegulationObligationsQueryVariables>;
export function useInternalRegulationObligationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationsQuery,
        IInternalRegulationObligationsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  IInternalRegulationObligationsQuery | undefined,
  IInternalRegulationObligationsQueryVariables
>;
export function useInternalRegulationObligationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        IInternalRegulationObligationsQuery,
        IInternalRegulationObligationsQueryVariables
      >,
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<IInternalRegulationObligationsQuery, IInternalRegulationObligationsQueryVariables>(
    InternalRegulationObligationsDocument,
    options,
  );
}
export type InternalRegulationObligationsQueryHookResult = ReturnType<typeof useInternalRegulationObligationsQuery>;
export type InternalRegulationObligationsLazyQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationsLazyQuery
>;
export type InternalRegulationObligationsSuspenseQueryHookResult = ReturnType<
  typeof useInternalRegulationObligationsSuspenseQuery
>;
export type InternalRegulationObligationsQueryResult = Apollo.QueryResult<
  IInternalRegulationObligationsQuery,
  IInternalRegulationObligationsQueryVariables
>;
